import { createFileRoute } from '@tanstack/react-router';
import { SupplierRegister } from '../../../features/purchasing-intake/SupplierRegister';

/** Owned by G20. Suppliers register + create/edit. */
export const Route = createFileRoute('/_authenticated/purchasing-intake/suppliers')({
  component: SupplierRegister,
});
